import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturKlausenLeopoldsdorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-klausen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-klausen-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="klausen-Leopoldsdorf" />
      </div>
    </div>
  );
}

export default BodentemperaturKlausenLeopoldsdorf;
